import styled from "styled-components";
import Button from "src/components/Common/Button";
import Wrap from "src/components/Wrap";

interface ContainerProps {
  show: boolean;
  notificationBar: boolean;
}

export const Container = styled.div<ContainerProps>`
  position: fixed;
  z-index: 2;
  /* top: 6.9rem; */
  top: ${({ notificationBar }) => (notificationBar ? "11rem" : "6.9rem")};
  display: none;
  background-color: ${({ theme }) => theme.colors.bg_pink};
  padding: 0.9rem 0;
  width: 100%;

  @media ${({ theme }) => theme.device.tablet} {
    display: ${({ show }) => (show ? "block" : "none")};
  }
`;

export const Nav = styled.nav``;

export const NavItem = styled.a`
  font-family: 'Effra-Regular';
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: ${({ theme }) => theme.colors.font_black};
  margin-right: 3rem;

  &.variant_A {
    display: none;
  }
`;

export const StyledButton = styled(Button)`
  /* width: 100%;
  padding-left: 0;
  padding-right: 0; */
  border-radius: 4px;
`;

export const StyledWrap = styled(Wrap)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
